import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import FormGroup from '@material-ui/core/FormGroup'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

import {
    MoreFilterContext,
    MoreFilterContextProps,
} from './Context/MoreFilterContext'
import CategoryCheckbox from './MoreFilterCategoryCheckbox/CategoryCheckbox'
import StatusCategoryCheckbox from './MoreFilterCategoryCheckbox/StatusCategoryCheckbox'

const useStyles = makeStyles((theme: Theme) => ({
    subProperty: {
        lineHeight: '3px',
        padding: '8px 24px',
        textTransform: 'capitalize',
    },
    subPropertyAutoWidth: {
        width: 'auto',
    },
    subPropertyMargin: {
        margin: 'auto -12px',
    },
    gridValues: {
        ...theme.typography.body1,
        padding: '0px !important',
    },
    checkboxAlign: {
        alignItems: 'flex-start',
        paddingTop: 16,
    },
    checkboxTopPadding: {
        paddingTop: 0,
    },
    labelAlign: {
        paddingTop: 2,
    },
}))

export interface optionItems {
    name: string
    value: string
}
interface MoreFilterCheckboxInterface {
    optionList: optionItems[]
    filterCategoryName: string
    disabledValues?: string[]
}
const MoreFilterCategoryCheckbox: React.FC<MoreFilterCheckboxInterface> = ({
    optionList,
    filterCategoryName,
    disabledValues,
}) => {
    const {
        selectedItems,
        onFilterSelectionChange,
        setSelection,
    } = React.useContext<MoreFilterContextProps>(MoreFilterContext)

    const classes = useStyles()
    const isSubmissionStatus: boolean =
        filterCategoryName === 'submissionStatus'

    const isAutoWidth =
        filterCategoryName == 'isDeltekWriterDraft' ||
        filterCategoryName == 'isActive'

    const selectedValues: string[] = selectedItems
        ? selectedItems[filterCategoryName]
        : []
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!onFilterSelectionChange || !setSelection) {
            return
        }
        let newSelection: string[] = []
        if (event.target.checked) {
            newSelection = selectedValues
                ? [...selectedValues, event.target.value]
                : [event.target.value]
        } else {
            newSelection = selectedValues
                ? selectedValues.filter((item) => item !== event.target.value)
                : []
        }
        const finalSelection: Record<string, string[]> = {
            ...selectedItems,
            [filterCategoryName]: newSelection,
        }
        onFilterSelectionChange(finalSelection)
        setSelection(finalSelection)
    }

    return (
        <>
            {isSubmissionStatus ? (
                <StatusCategoryCheckbox
                    optionList={optionList}
                    selectedValues={selectedValues}
                    handleChange={handleChange}
                    disabledValues={disabledValues}
                />
            ) : (
                <GridContainer
                    data-testid="moreFilterCategoryCheckbox"
                    className={clsx(
                        classes.subProperty,
                        classes.subPropertyMargin,
                        isAutoWidth && classes.subPropertyAutoWidth
                    )}
                    spacing={3}
                >
                    <FormGroup row>
                        {optionList.map((item, index) => (
                            <GridItem
                                className={classes.gridValues}
                                key={item.value}
                            >
                                <CategoryCheckbox
                                    item={item}
                                    itemKey={`${item.name}${index}`}
                                    isSelected={
                                        !!selectedValues?.includes(item.value)
                                    }
                                    isDisabled={disabledValues?.includes(
                                        item.value
                                    )}
                                    handleChange={handleChange}
                                />
                            </GridItem>
                        ))}
                    </FormGroup>
                </GridContainer>
            )}
        </>
    )
}

export default MoreFilterCategoryCheckbox
